module.exports = __webpack_public_path__ + "static/img/40.9a18b3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/40.png
// module id = 4tQ6
// module chunks = 0